import React from 'react';

import { useFormContext } from 'react-hook-form';

import { DateRangeFilter } from 'components/common/CustomFilters/DateRangeFilter/DateRangeFilter';
import { TabOptions } from 'components/common/CustomFilters/DateRangeFilter/DateRangeFilter.utils';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import { getInputValue } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.utils';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';

export const BaselineEndDate = ({ isSelected, onFiltersChanged }) => {
    const { watch } = useFormContext<IFields>();
    const baselineEndDateExistingData = {
        type: watch('baselineEndDate').type,
        value:
            watch('baselineEndDate').value.length === 0
                ? watch('flags').baselineEndDatesRange
                : watch('baselineEndDate').value,
    };

    const handleBaselineEndDateSelection = (data: { value?: string[] | string; type?: TabOptions }) => {
        if (data.type === 'FIXED_DATE') {
            const tempFlags = watch('flags');
            delete tempFlags.baselineEndDatesRange;
            onFiltersChanged({
                baselineEndDate: {
                    value: Array.isArray(data.value) ? data.value.map(String) : [],
                    type: data.type,
                },
                flags: tempFlags,
            });
        } else {
            onFiltersChanged({
                baselineEndDate: { value: [], type: data.type },
                flags: {
                    ...watch('flags'),
                    baselineEndDatesRange: data.value as string,
                },
            });
        }
    };
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Baseline Finish Date</span>
            <DateRangeFilter
                onChange={handleBaselineEndDateSelection}
                value={baselineEndDateExistingData}
                inputDefaultValue={getInputValue(baselineEndDateExistingData)}
            />
        </div>
    ) : null;
};
